import { Injectable } from '@angular/core';
import { Message } from 'primeng/api';
import { Subject } from 'rxjs';

type Severities = 'success' | 'info' | 'warn' | 'error';
type SummaryDetails = 'Success Message' | 'Error Message' | 'Warning Message' | 'Information Message';
@Injectable()
export class NotificationsService {
  growlNotificationChange: Subject<Object> = new Subject<Object>();

  toastNotify(severity: Severities, summary: SummaryDetails, detail: string, isSticky: boolean = false) {
    this.growlNotificationChange.next({ severity, summary, detail, sticky: isSticky });
  }
}
export class ToastMessage implements Message {
  severity?: string;
  summary?: string;
  detail?: string;
  id?: any;
  key?: string;
  isSticky?: boolean;
}
